/* VIPA preview-only registration finder enhancement, visual only. */
(function () {
  'use strict';
  function enhance() {
    var root = document.querySelector('#MainContent .reg-finder-container');
    if (!root) return;
    var form = root.querySelector('form#reg-finder-form');
    var input = form && form.querySelector('input#reg[name="reg"]');
    var block = form && form.closest('.reg-finder__block');
    if (!form || !input || !block || form.getAttribute('data-vipa-design-ready') === '1') return;
    form.setAttribute('data-vipa-design-ready', '1');
    input.setAttribute('placeholder','AB12 CDE');
    input.setAttribute('aria-label','Vehicle registration');
    input.setAttribute('autocapitalize','characters');
    input.setAttribute('spellcheck','false');
    if (!block.querySelector('.vipa-hero-reg-label')) {
      var label = document.createElement('label');
      label.className='vipa-hero-reg-label';
      label.htmlFor='reg';
      label.textContent='Enter your UK registration';
      block.insertBefore(label,form);
    }
    if (!root.querySelector('.vipa-hero-reg-support')) {
      var support = document.createElement('div');
      support.className='vipa-hero-reg-support';
      support.setAttribute('aria-label','Why shop with VIPA');
      ['✓ Exact vehicle fit','✓ No adapters','✓ Free UK delivery'].forEach(function(item) {
        var chip = document.createElement('span');
        chip.textContent=item;
        support.appendChild(chip);
      });
      block.insertAdjacentElement('afterend',support);
    }
    var browse = document.getElementById('vipa-browse-wipers-by-make');
    if (browse && !root.querySelector('.vipa-hero-reg-browse')) {
      var link = document.createElement('a');
      link.className='vipa-hero-reg-browse';
      link.href='#vipa-browse-wipers-by-make';
      link.textContent="Don't have your reg? Browse by make ↓";
      support.insertAdjacentElement('afterend',link);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',enhance,{once:true});
  } else {
    enhance();
  }
  window.addEventListener('load',enhance,{once:true});
})();

/* VIPA confirmed vehicle image — persistent, registration-matched and trusted-host only.
   Uses the exact vehicle image returned by the registration provider; never guesses a car. */
(function () {
  'use strict';
  var keyV3 = 'vipa-confirmed-vehicle-image-v3';
  var keyV2 = 'vipa-confirmed-vehicle-image-v2';
  var localTtl = 24 * 60 * 60 * 1000;
  var sessionTtl = 4 * 60 * 60 * 1000;

  function normalisePlate(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function validatedImageUrl(value) {
    try {
      var u = new URL(String(value || ''), window.location.href);
      if (u.protocol !== 'https:') return '';
      var host = u.hostname.toLowerCase();
      var path = u.pathname || '';
      if (/vehicle-placeholder/i.test(path)) return '';

      if (host === 'vehicleimages.ukvehicledata.co.uk' && path.indexOf('/s3/') === 0) return u.href;
      if ((host === 'static.vipaconversion.com' || host === 'www.vipaconversion.com' || host === 'vipaconversion.com') &&
          (path.indexOf('/images/') === 0 || path.indexOf('/assets/img/car/') === 0)) return u.href;
      if ((host === 'www.vipacarparts.com' || host === 'vipacarparts.com') && path.indexOf('/assets/img/car/') === 0) return u.href;
      return '';
    } catch (e) { return ''; }
  }

  function imageFromElement(img) {
    if (!img) return '';
    var candidates = [
      img.currentSrc,
      img.getAttribute('src'),
      img.getAttribute('data-src'),
      img.getAttribute('data-image'),
      img.getAttribute('data-original')
    ];
    var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    if (srcset) {
      srcset.split(',').forEach(function (part) {
        candidates.push((part.trim().split(/\s+/)[0] || ''));
      });
    }
    for (var i = 0; i < candidates.length; i++) {
      var good = validatedImageUrl(candidates[i]);
      if (good) return good;
    }
    return '';
  }

  function writeInfo(info) {
    if (!info || !info.registration || !info.image) return;
    var raw = JSON.stringify(info);
    try { sessionStorage.setItem(keyV3, raw); } catch (e) {}
    try { localStorage.setItem(keyV3, raw); } catch (e) {}
  }

  function clearInfo() {
    try { sessionStorage.removeItem(keyV3); sessionStorage.removeItem(keyV2); } catch (e) {}
    try { localStorage.removeItem(keyV3); localStorage.removeItem(keyV2); } catch (e) {}
  }

  function readStorage(store, key, ttl) {
    try {
      var value = JSON.parse(store.getItem(key) || 'null');
      if (!value || !value.registration || !value.image || !value.capturedAt) return null;
      if (Date.now() - Number(value.capturedAt) > ttl) return null;
      var image = validatedImageUrl(value.image);
      if (!image) return null;
      value.image = image;
      return value;
    } catch (e) { return null; }
  }

  function readStoredInfo() {
    return readStorage(sessionStorage, keyV3, sessionTtl) ||
           readStorage(localStorage, keyV3, localTtl) ||
           readStorage(sessionStorage, keyV2, sessionTtl);
  }

  function imageFromRegResult(expectedPlate) {
    try {
      var data = JSON.parse(localStorage.getItem('regResult') || 'null');
      if (!data) return null;
      var reg = normalisePlate(data.reg || data.registration || '');
      if (!reg || reg !== normalisePlate(expectedPlate)) return null;
      var keys = ['image','imageUrl','image_url','vehicleImage','vehicle_image','vehicleImageUrl','vehicle_image_url','photo','photoUrl','photo_url'];
      for (var i = 0; i < keys.length; i++) {
        var image = validatedImageUrl(data[keys[i]]);
        if (image) return { registration: reg, image: image, capturedAt: Date.now() };
      }
    } catch (e) {}
    return null;
  }

  /* Capture the exact vehicle image only when the customer confirms this is their vehicle. */
  document.addEventListener('click', function (event) {
    var clicked = event.target && event.target.closest && event.target.closest('button, a, input[type="submit"], input[type="button"], [role="button"]');
    if (!clicked || !clicked.closest('#vehicle-confirm__modal')) return;
    var answer = String(clicked.textContent || clicked.value || '').trim();
    if (/^no\b/i.test(answer)) {
      clearInfo();
      return;
    }
    if (!/^yes\b[\s\S]*\bmy\s+vehicle\b/i.test(answer)) return;

    var picture = document.querySelector('#vehicle-confirm__modal img#vehicleImage');
    var image = imageFromElement(picture);
    var input = document.querySelector('#reg-finder-form input#reg, #reg-finder-form input[name="reg"], input#reg');
    var plate = normalisePlate(input && input.value);
    if (!plate || !image) return;
    writeInfo({ registration: plate, image: image, capturedAt: Date.now() });
  }, true);

  if (!/^\/collections\/wipers-for-your-vehicle\/?$/.test(window.location.pathname)) return;

  function insertWhenReady() {
    var plateNode = document.querySelector('#your-vehicle .icon-reg .your-vehicle__reg');
    if (!plateNode) return false;
    var currentPlate = normalisePlate(plateNode.textContent);
    if (!currentPlate) return true;

    var info = readStoredInfo();
    if (!info) {
      info = imageFromRegResult(currentPlate);
      if (info) writeInfo(info);
    }
    if (!info || normalisePlate(info.registration) !== currentPlate) return true;

    var image = validatedImageUrl(info.image);
    if (!image) return true;
    var wrapper = plateNode.closest('.icon-reg');
    if (!wrapper || wrapper.querySelector('.vipa-confirmed-vehicle-photo')) return true;

    var photo = document.createElement('img');
    photo.className = 'vipa-confirmed-vehicle-photo';
    photo.width = 176;
    photo.height = 116;
    photo.alt = 'Vehicle image for registration ' + plateNode.textContent.trim();
    photo.decoding = 'async';
    photo.loading = 'eager';
    photo.addEventListener('load', function () {
      if (plateNode.isConnected && normalisePlate(plateNode.textContent) === currentPlate) {
        wrapper.insertBefore(photo, plateNode);
      }
    }, { once: true });
    photo.addEventListener('error', function () { photo.remove(); }, { once: true });
    photo.src = image;
    return true;
  }

  if (insertWhenReady()) return;
  var watcher = new MutationObserver(function () {
    if (insertWhenReady()) watcher.disconnect();
  });
  watcher.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { watcher.disconnect(); }, 20000);
})();

/* VIPA vehicle selector presentation hook; does not change finder data or callbacks. */
(function(){
  'use strict';
  var scheduled=false;
  function decorate() {
    if(!document.body)return;
    var confirm=document.querySelector('.vehicle-confirm__modal .vehicle-confirm__block');
    if(confirm)confirm.classList.add('vipa-finder-confirm-panel');
    document.querySelectorAll('select[name="make"]').forEach(function(select){
      var parent=select.parentElement;
      for(var level=0;parent&&parent!==document.body&&level<12;level++,parent=parent.parentElement){
        if(!parent.querySelector('select[name="model"]') || !parent.querySelector('select[name="body-style"]'))continue;
        var headings=parent.querySelectorAll('h1,h2,h3'),found=false;
        for(var i=0;i<headings.length;i++){
          if(/^select your vehicle$/i.test((headings[i].textContent||'').trim())){found=true;break;}
        }
        if(!found)continue;
        var width=parent.getBoundingClientRect().width;
        if(width>180 && width<Math.min(900,window.innerWidth*.85))parent.classList.add('vipa-finder-manual-panel');
        break;
      }
    });
  }
  function schedule(){
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(function(){scheduled=false;decorate();});
  }
  function init(){
    decorate();
    if(!document.querySelector('.reg-finder-container'))return;
    document.addEventListener('click',function(e){
      if(e.target && e.target.closest && e.target.closest('.reg-finder-container, .vehicle-confirm__modal')){
        schedule();setTimeout(decorate,160);setTimeout(decorate,500);
      }
    },true);
    new MutationObserver(function(){
      if(document.querySelector('.vehicle-confirm__modal')||document.querySelector('select[name="make"]'))schedule();
    }).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();


/* VIPA_MANUAL_VEHICLE_POPUP_V5_START */
(function () {
  'use strict';

  if (window.__vipaManualVehiclePopupV5) return;
  window.__vipaManualVehiclePopupV5 = true;

  var modelMap = {};
  var modelPromise = null;

  function config() {
    return window.VIPA_MANUAL_FINDER_CONFIG || {};
  }

  function loadModelMap() {
    if (modelPromise) return modelPromise;
    var url = config().modelsUrl;
    if (!url) return Promise.reject(new Error('Vehicle data unavailable'));

    modelPromise = fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Vehicle data unavailable');
        return response.json();
      })
      .then(function (data) {
        modelMap = data || {};
        return modelMap;
      });

    return modelPromise;
  }

  function addOptions(select, values, placeholder) {
    select.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);

    (values || []).forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  }

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function parseFit(title, make, model) {
    var titleText = String(title || '');
    if (!normalise(titleText).includes(normalise(make + ' ' + model))) return null;

    var lowerTitle = titleText.toLowerCase();
    var lowerVehicle = (make + ' ' + model).toLowerCase();
    var index = lowerTitle.indexOf(lowerVehicle);
    var remainder = index >= 0 ? titleText.slice(index + lowerVehicle.length).trim() : titleText;

    var month = '(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t|tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)';
    var datePattern = new RegExp('\\b' + month + '\\s+\\d{4}(?:\\s*(?:-|to)\\s*' + month + '\\s+\\d{4}|\\s+Onwards)?\\b', 'i');
    var dateMatch = remainder.match(datePattern);

    if (!dateMatch) {
      dateMatch = remainder.match(/\b(?:19|20)\d{2}(?:\s*(?:-|to)\s*(?:19|20)\d{2}|\s+Onwards)?\b/i);
    }
    if (!dateMatch) return null;

    var body = remainder.slice(0, dateMatch.index).trim();
    body = body
      .replace(/\b(?:front|rear|wiper|blade|kit|set)\b.*$/i, '')
      .replace(/\s+/g, ' ')
      .trim();

    if (!body) body = 'All body styles';

    return {
      body: body,
      date: dateMatch[0].replace(/\s+/g, ' ').trim()
    };
  }

  function fetchFits(make, model) {
    var url = new URL('/search/suggest.json', window.location.origin);
    url.searchParams.set('q', make + ' ' + model + ' wiper');
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '10');
    url.searchParams.set('resources[options][unavailable_products]', 'show');

    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Vehicle details unavailable');
        return response.json();
      })
      .then(function (payload) {
        var products =
          payload &&
          payload.resources &&
          payload.resources.results &&
          payload.resources.results.products
            ? payload.resources.results.products
            : [];

        var fits = new Map();

        products.forEach(function (product) {
          var fit = parseFit(product.title, make, model);
          if (!fit) return;
          if (!fits.has(fit.body)) fits.set(fit.body, new Set());
          fits.get(fit.body).add(fit.date);
        });

        return fits;
      });
  }

  function findOverlay(form) {
    var node = form.parentElement;
    while (node && node !== document.body) {
      var style = window.getComputedStyle(node);
      var rect = node.getBoundingClientRect();
      if (
        style.position === 'fixed' &&
        rect.width >= window.innerWidth * 0.65 &&
        rect.height >= window.innerHeight * 0.65
      ) {
        return node;
      }
      node = node.parentElement;
    }
    return null;
  }

  function closePopup(form, overlay) {
    form.style.setProperty('display', 'none', 'important');
    if (overlay) overlay.style.setProperty('display', 'none', 'important');
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
  }

  function replacePopup(form) {
    if (!form || form.querySelector('[data-vipa-refresh-root]')) return;

    var overlay = findOverlay(form);
    form.setAttribute('data-vipa-manual-replaced', '1');
    form.innerHTML =
      '<div class="vipa-refresh-popup" data-vipa-refresh-root>' +
        '<h2 class="vipa-refresh-popup__title">SELECT YOUR VEHICLE</h2>' +
        '<p class="vipa-refresh-popup__intro">Choose your vehicle to find the correct VIPA wiper blades.</p>' +
        '<div class="vipa-refresh-popup__field">' +
          '<label for="vipa-refresh-make">MAKE</label>' +
          '<select id="vipa-refresh-make" data-vipa-refresh-make><option value="">Please select</option></select>' +
        '</div>' +
        '<div class="vipa-refresh-popup__field">' +
          '<label for="vipa-refresh-model">MODEL</label>' +
          '<select id="vipa-refresh-model" data-vipa-refresh-model disabled><option value="">Please select</option></select>' +
        '</div>' +
        '<div class="vipa-refresh-popup__field">' +
          '<label for="vipa-refresh-body">VEHICLE TYPE</label>' +
          '<select id="vipa-refresh-body" data-vipa-refresh-body disabled><option value="">Please select</option></select>' +
        '</div>' +
        '<div class="vipa-refresh-popup__field">' +
          '<label for="vipa-refresh-date">YEAR / DATE RANGE</label>' +
          '<select id="vipa-refresh-date" data-vipa-refresh-date disabled><option value="">Please select</option></select>' +
        '</div>' +
        '<button type="button" class="vipa-refresh-popup__find" data-vipa-refresh-find disabled>FIND MY WIPER BLADES</button>' +
        '<p class="vipa-refresh-popup__status" data-vipa-refresh-status></p>' +
        '<button type="button" class="vipa-refresh-popup__close" data-vipa-refresh-close>CLOSE</button>' +
      '</div>';

    var makeSelect = form.querySelector('[data-vipa-refresh-make]');
    var modelSelect = form.querySelector('[data-vipa-refresh-model]');
    var bodySelect = form.querySelector('[data-vipa-refresh-body]');
    var dateSelect = form.querySelector('[data-vipa-refresh-date]');
    var findButton = form.querySelector('[data-vipa-refresh-find]');
    var closeButton = form.querySelector('[data-vipa-refresh-close]');
    var status = form.querySelector('[data-vipa-refresh-status]');
    var fitMap = new Map();

    function resetAfterMake() {
      addOptions(modelSelect, [], 'Please select');
      addOptions(bodySelect, [], 'Please select');
      addOptions(dateSelect, [], 'Please select');
      modelSelect.disabled = true;
      bodySelect.disabled = true;
      dateSelect.disabled = true;
      findButton.disabled = true;
      fitMap = new Map();
    }

    function resetAfterModel() {
      addOptions(bodySelect, [], 'Please select');
      addOptions(dateSelect, [], 'Please select');
      bodySelect.disabled = true;
      dateSelect.disabled = true;
      findButton.disabled = true;
      fitMap = new Map();
    }

    function resetAfterBody() {
      addOptions(dateSelect, [], 'Please select');
      dateSelect.disabled = true;
      findButton.disabled = true;
    }

    loadModelMap()
      .then(function (data) {
        var makes = Object.keys(data).sort(function (a, b) {
          return a.localeCompare(b);
        });
        addOptions(makeSelect, makes, 'Please select');
        status.textContent = '';
      })
      .catch(function () {
        makeSelect.disabled = true;
        status.textContent = 'Vehicle list could not be loaded. Please refresh and try again.';
      });

    makeSelect.addEventListener('change', function (event) {
      event.stopPropagation();
      resetAfterMake();
      status.textContent = '';

      var models = modelMap[makeSelect.value] || [];
      if (!models.length) return;

      addOptions(modelSelect, models, 'Please select');
      modelSelect.disabled = false;
    });

    modelSelect.addEventListener('change', function (event) {
      event.stopPropagation();
      resetAfterModel();
      status.textContent = '';

      if (!makeSelect.value || !modelSelect.value) return;

      status.textContent = 'Loading vehicle types and years...';

      fetchFits(makeSelect.value, modelSelect.value)
        .then(function (fits) {
          fitMap = fits;

          if (!fitMap.size) {
            fitMap.set('All body styles', new Set(['All years']));
            status.textContent = 'Choose continue to search all available versions.';
          } else {
            status.textContent = '';
          }

          addOptions(bodySelect, Array.from(fitMap.keys()), 'Please select');
          bodySelect.disabled = false;
        })
        .catch(function () {
          fitMap = new Map([['All body styles', new Set(['All years'])]]);
          addOptions(bodySelect, ['All body styles'], 'Please select');
          bodySelect.disabled = false;
          status.textContent = 'Choose continue to search all available versions.';
        });
    });

    bodySelect.addEventListener('change', function (event) {
      event.stopPropagation();
      resetAfterBody();

      var dates = fitMap.get(bodySelect.value);
      if (!dates) return;

      addOptions(dateSelect, Array.from(dates), 'Please select');
      dateSelect.disabled = false;
    });

    dateSelect.addEventListener('change', function (event) {
      event.stopPropagation();
      findButton.disabled = !dateSelect.value;
    });

    findButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var make = makeSelect.value.trim();
      var model = modelSelect.value.trim();
      var body = bodySelect.value.trim();
      var date = dateSelect.value.trim();

      if (!make || !model || !body || !date) return;

      var terms = [make + ' ' + model];
      if (body !== 'All body styles') terms.push(body);
      if (date !== 'All years') terms.push(date);

      var target = new URL(config().searchUrl || '/search', window.location.origin);
      target.searchParams.set(
        'q',
        terms.map(function (term) { return 'title:"' + term + '"'; }).join(' AND ') + ' AND title:wiper'
      );
      target.searchParams.set('type', 'product');
      target.searchParams.set('options[prefix]', 'none');

      var previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewThemeId) target.searchParams.set('preview_theme_id', previewThemeId);

      window.location.assign(target.toString());
    });

    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closePopup(form, overlay);
    });
  }

  function scan() {
    document.querySelectorAll('.select-your-vehicle-form').forEach(replacePopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  window.addEventListener('load', scan, { once: true });

  var observer = new MutationObserver(function () {
    window.requestAnimationFrame(scan);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.setTimeout(scan, 300);
  window.setTimeout(scan, 1000);
  window.setTimeout(scan, 2500);
})();
/* VIPA_MANUAL_VEHICLE_POPUP_V5_END */

